export const PODCASTER_SESSION_ID = 'podcaster-session-id';
export const SESSION_ID = 'session-id';
export const UNIQUE_BROWSER_ID = 'ubid-main';
export const ACCEPT_ALL = 'ACCEPT-ALL';
export const REJECT_ALL = 'REJECT-ALL';
export const UNKNOWN = 'UNKNOWN';
